import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { audience } from '../../data/content';

/** Section 13 — who it is for. */
export function AudienceSection() {
  return <section aria-labelledby="audience-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-32" data-mp="1y9er5lhv0udg">
      <div className="mx-auto max-w-5xl" data-id="element-33" data-mp="1t7z3rms7mbrw">
        <SectionHeading id="audience-heading" title={<>
              Created for Makeup Professionals <Accent data-id="element-35" data-mp="238htuzadaoi9">Who Teach.</Accent>
            </>} data-id="element-34" data-mp="286t1d3d6wmxb" />

        <ul className="mt-12 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4" role="list" data-id="element-36" data-mp="2gyv2z4yzw996">
          {audience.map(item => <li key={item} className="flex items-center gap-3 rounded-[16px] border border-brand-charcoal/10 bg-white px-4 py-4 text-[15px] font-medium leading-snug text-brand-charcoal" data-id="element-37" data-mp="2cyklow5r5wf0">
              <span className="flex h-7 w-7 flex-none items-center justify-center rounded-full bg-brand-lavender" data-id="element-38" data-mp="2m00vp2snnwip">
                <CheckIcon className="h-4 w-4 text-brand-plum" strokeWidth={2.5} aria-hidden="true" data-id="element-39" data-mp="1sdx83mppo1so" />
              </span>
              {item}
            </li>)}
        </ul>

        <p className="mx-auto mt-12 max-w-3xl text-center font-display text-[1.6rem] font-bold leading-snug text-brand-charcoal sm:text-[1.9rem]" data-id="element-40" data-mp="228gvx7igvzgh">
          If you know makeup but need a better way to <Accent data-id="element-41" data-mp="2ba6j215bgc8g">organize</Accent> how you teach it, this system
          was built for you.
        </p>
      </div>
    </section>;
}